import {VipConfigVO} from '@/common-pages/vip/vip.service';
import {getCurrentVip} from '@/utils/vip';

export const getVipLevel = (vipList: VipConfigVO[]) => {
  const sortedList = [...vipList].sort(
    (a, b) => (a.level || 0) - (b.level || 0),
  );
  const {currentVip} = getCurrentVip(sortedList);
  return currentVip?.level || 0;
};
